import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp } from '@nu-art/thunderstorm-frontend/index';
import { dbObjectToId, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Advisor_Action, ModuleFE_Advisor_OrderGroup } from '@app/advisor-frontend';
import { ICONS } from '@app/styles';
import './PopUp_OrderGroupsResolver.scss';
import { ModuleFE_RuntimeOrder } from '@app/advisor-frontend';
import { RuntimeOrderStatus_Enum } from '@app/advisor-shared';
import { Renderer_GroupOrder } from './Renderer_GroupOrder.js';
export class PopUp_OrderGroupsResolver extends ComponentSync {
    static show = (e, props) => {
        // @ts-ignore - getBoundingClientRect exists on target
        const rect = e.target.getBoundingClientRect();
        const _props = { ...props, groupIds: PopUp_OrderGroupsResolver.resolveGroupIds(props.groupIds, props.pickedRTOrders) };
        //No groups to resolve
        if (!_props.groupIds.length)
            return props.onSubmit({});
        const model = {
            id: 'pop-up__order-group-resolver',
            modalPos: { x: -1, y: -1 },
            originPos: { x: rect.right, y: rect.top },
            offset: { y: 8 },
            xAxisAnchor: 'right',
            yAxisAnchor: 'bottom',
            ignoreOverlayClick: true,
            content: () => _jsx(PopUp_OrderGroupsResolver, { ..._props }),
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    static resolveGroupIds = (groupIds, pickedRTOrders) => {
        if (!pickedRTOrders?.length)
            return groupIds;
        let groups = groupIds.map(id => {
            const group = ModuleFE_Advisor_OrderGroup.cache.unique(id);
            if (!group)
                throw new MUSTNeverHappenException(`Could not find an order group for id ${id}`);
            return group;
        });
        //Filter groups that are already resolved
        groups = groups.filter(group => {
            const orderIds = group.items.map(pointer => pointer.id);
            //Pass only groups that aren't resolved by an already picked rtOrder
            return !pickedRTOrders?.find(rtOrder => orderIds.includes(rtOrder.orderId));
        });
        return groups.map(dbObjectToId);
    };
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        //Translate group ids to groups
        state.groups = nextProps.groupIds.map(id => {
            const group = ModuleFE_Advisor_OrderGroup.cache.unique(id);
            if (!group)
                throw new MUSTNeverHappenException(`Could not find an order group for id ${id}`);
            return group;
        });
        state.orderIdMapper = {};
        state.currentGroupId = state.groups[0]?._id;
        state.busy ??= false;
        return state;
    }
    //######################### Logic #########################
    closePopUp = () => {
        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
    };
    getOrders = (group) => {
        let orderIds = group.items.map(pointer => pointer.id);
        if (this.props.limitToExistingRecommendedOrders)
            orderIds = orderIds.filter(orderId => {
                return !!ModuleFE_RuntimeOrder.cache.find(rtOrder => rtOrder.orderId === orderId && rtOrder.orderStatus === RuntimeOrderStatus_Enum.RECOMMENDED);
            });
        return orderIds.map(id => {
            const order = ModuleFE_Advisor_Action.cache.unique(id);
            if (!order)
                throw new MUSTNeverHappenException(`Could not find order for id ${id}`);
            return order;
        });
    };
    onOrderSelect = async (group, order) => {
        if (this.state.busy)
            return;
        //Assign order to group
        this.state.orderIdMapper[group._id] = order._id;
        //Get next group id
        const groupIndex = this.state.groups.findIndex(g => g._id === group._id);
        const nextGroupId = this.state.groups[groupIndex + 1]?._id;
        if (nextGroupId) { //Continue to next group
            return this.setState({ currentGroupId: nextGroupId });
        }
        else { //No next group - Submit
            this.setState({ busy: true });
            try {
                await this.props.onSubmit(this.state.orderIdMapper);
                this.closePopUp();
            }
            catch (err) {
                this.setState({ busy: false });
            }
        }
    };
    //######################### Render #########################
    render() {
        const currentGroup = this.state.groups.find(g => g._id === this.state.currentGroupId);
        return _jsxs(_Fragment, { children: [this.render_Header(currentGroup), this.render_Orders(currentGroup), this.render_Footer(currentGroup)] });
    }
    render_Header = (currentGroup) => {
        return _jsxs(LL_H_C, { className: 'order-group-resolver__header', children: [_jsxs("div", { className: 'order-group-resolver__header-title', children: ["Select Order: ", currentGroup.label ?? currentGroup.name] }), _jsx(ICONS.advisor_avn_close.component, { onClick: this.closePopUp })] });
    };
    render_Orders = (currentGroup) => {
        const orders = this.getOrders(currentGroup);
        return _jsx(LL_V_L, { className: 'order-group-resolver__orders', children: orders.map(order => {
                return _jsx(Renderer_GroupOrder, { order: order, onClick: () => this.onOrderSelect(currentGroup, order) }, order._id);
            }) });
    };
    render_Footer = (currentGroup) => {
        if (this.state.groups.length <= 1)
            return;
        const currentGroupIndex = this.state.groups.findIndex(g => g._id === currentGroup._id);
        return _jsx(LL_H_C, { className: 'order-group-resolver__footer', children: _jsxs("div", { className: 'order-group-resolver__footer__group-counter', children: [currentGroupIndex + 1, " / ", this.state.groups.length] }) });
    };
}
//# sourceMappingURL=PopUp_OrderGroupsResolver.js.map